import configureStore from './configureStore';


const store = configureStore();

if (!import.meta.env.PROD) {
  window.store = store;
}

export default store;
